import { gameColorsCodes, gameColorsOdd } from '../enums/gameColors';

const decideColor = (bet, isReturnColor, isHistoryBlock) => {
  let color = '';
  if (isHistoryBlock) {
    color = bet.market;
    return isReturnColor ? color : gameColorsOdd[gameColorsCodes[color]];
  }

  const additionalData = bet.additionalParams || bet.betData;

  if (additionalData && additionalData.markets.length) {
    color = additionalData.markets[0].market;
  }

  return isReturnColor ? color : gameColorsOdd[gameColorsCodes[color]];
};
export { decideColor };
